import {ConnectedComponent, sharedComponent} from 'lowkey-component'

import {createApplicationState} from '@services/ApplicationState'
import {IApplicationState} from '@services/types'
import {colors} from '@services/utils'
import {appSelectors} from '@store/appSlice'
import {navSelectors} from '@store/navSlice'

@sharedComponent
export class HamburgerButton extends ConnectedComponent {
  private appService: IApplicationState = createApplicationState();
  private dots: HTMLDivElement[] = [];

  open() {
    this.appService.updateIsOpenGlobalNav(true);
    this.element?.classList.add('open');
  }

  close() {
    this.appService.updateIsOpenGlobalNav(false);
    setTimeout(() => {
      this.element?.classList.remove('open');
    }, 100);
  }

  isOpen() {
    return this.element?.classList.contains('open');
  }

  didMount() {
    this.dots = [...this.element.querySelectorAll('.dot')] as HTMLDivElement[];
    this.observe(appSelectors.selectPageIndicatorStatus, (status) => {
      if (status === 'endShowAnimation') {
        this.close();
      }
    });

    this.observe(navSelectors.selectIsShowHeaderNavMenu, async (isShow) => {
      if (isShow) {
        this.dots.map((dot) => {
          dot.style.backgroundColor = colors.white;
        });
      } else {
        this.dots.map((dot) => {
          dot.style.backgroundColor = '';
        });
      }
    });

    this.observe(navSelectors.selectHeaderNavDisplayState, (state) => {
      switch (state) {
        case 'hide':
          this.element.classList.add('hide');
          this.element.classList.remove('show');
          return;
        case 'show':
          this.element.classList.add('show');
          this.element.classList.remove('hide');
          return;
        case undefined:
          this.element.classList.remove('hide');
          this.element.classList.remove('show');
          return;
      }
    });

    this.on('mouseenter', () => {
      this.element?.classList.add('hover');
    });
    this.on('mouseleave', () => {
      this.element?.classList.remove('hover');
    });

    this.on('click', () => {
      if (this.element?.classList.contains('open')) {
        this.close();
      } else {
        this.open();
      }
    });
  }

  down() {
    this.element?.classList.add('down');
  }

  up() {
    this.element?.classList.remove('down');
  }
}
